import { createTheme, responsiveFontSizes } from '@mui/material';
import { viewportContextValues } from './utils/ViewportUtils';

let adnocTheme = createTheme({
    palette: {
        mode: 'light',
        background: {
            default: '#000000',
        },
    },
    spacing: viewportContextValues.is4k ? 12 : 8,
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1280,
            xl: 1920
        }
    },
    typography: {
        fontFamily: "'ADNOC Sans', Arial",
        h1: {
            fontWeight: "bold",
            color: "var(--text-primary)"
        },
        h2: {
            fontWeight: "bold",
            color: "var(--text-primary)"
        },
        h3: {
            fontWeight: "bold",
            color: "var(--text-primary)"
        },
        h4: {
            fontWeight: "bold",
            color: "var(--text-primary)"
        },
        h5: {
            fontWeight: "bold",
            color: "var(--text-primary)"
        },
        h6: {
            fontWeight: "bold",
            color: "var(--text-primary)"
        },
        subtitle1: {
            fontWeight: "bold",
            color: "var(--text-primary)"
        },
        body1: {
            color: "var(--text-primary)"
        },
        body2: {
            color: "var(--text-primary)"
        },
        caption: {
            fontWeight: 'bold',
            color: 'var(--text-primary)'
        }
    },
    components: {
        MuiLink: {
            variants: [{
                props: { variant: 'caption' },
                style: {
                    fontWeight: 400,
                    color: "var(--link-color)",
                    textDecoration: 'underline',
                    '&:hover': {
                        cursor: 'pointer'
                    }
                }
            }],
            styleOverrides: {
                root: {
                    fontWeight: 'bold',
                    color: 'var(--text-primary)',
                    textDecoration: 'underline',
                    transition: 'opacity 200ms ease-in-out',
                    '&:hover': {
                        cursor: 'pointer',
                        opacity: 0.85,
                    }
                }
            }
        },
        MuiButton: {
            variants: [
                {
                    props: { variant: "contained" },
                    style: {
                        color: 'var(--text-primary)',
                        textTransform: 'none',
                        background: 'linear-gradient(139.07deg, #5A4EB4 -401.71%, #00A9B1 -61.32%, #2E79B3 110.16%)',
                        boxShadow: '0px 4px 4px 0px #00000040',
                        borderRadius: 20,
                        outline: 'none',
                        border: 'none',
                        '& .MuiButton-icon': {
                            fill: 'var(--text-primary)',
                        }
                    }
                },
                {
                    props: { variant: 'text' },
                    style: {
                        textTransform: 'none',
                        fontWeight: 400,
                        color: "var(--link-color)",
                        '&:hover': {
                            cursor: 'pointer'
                        }
                    }
                }
            ]
        },
        MuiChip: {
            variants: [
                {
                    props: { variant: 'filled' },
                    style: {
                        fontWeight: 'bold',

                        background: '#1E91E0',
                        color: 'white',
                        padding: '16px',
                    }
                }
            ]
        },
        MuiAccordion: {
            styleOverrides: {
                root: {
                    color: "var(--text-primary)",
                    background: '#C3C3C31A',
                    borderRadius: 12,
                    padding: 2,
                    boxSizing: 'border-box',
                    position: 'relative',
                    '&:first-of-type, &:last-of-type': {
                        borderRadius: 12,
                    },
                    '& .MuiAccordionSummary-content': {
                        display: 'flex',
                        alignItems: 'center'
                    },
                    '.MuiCollapse-root': {
                        px: 1,
                        py: 0
                    }
                }
            }
        },
        MuiSelect: {
            variants: [
                {
                    props: { variant: 'outlined' },
                    style: {
                        color: 'var(--text-primary)',
                        padding: 2,
                        borderRadius: '16px',
                        minWidth: 100,
                        height: 'auto',
                        '&:focus': {
                            border: 'none'
                        },
                        '& .MuiSelect-select': {
                            padding: '8px 16px'
                        },
                        '& .MuiSelect-icon': {
                            fill: 'var(--text-primary)',
                        }
                    }
                }
            ]
        }
    }
})

adnocTheme = responsiveFontSizes(adnocTheme);

export default adnocTheme;